<template>
  <div class="page">
    <div class="card-content">
      <div class="card-iccid-item">
        <span style="margin-right:5px">{{ $t('cardInfo.iccid') }}:</span>
        <span>{{iccid}}</span>
      </div>
      <div class="card-country-item">
        <div class="country">
          <span style="margin-right:5px">{{ $t('common.country') }}:</span>
          <span>{{countryName}}</span>
        </div>
        <div class="switch" @click="switchCountry">
          <img style="width:20px" :src="require('../../assets/svg/switch.svg')">
        </div>
      </div>
    </div>
    <div class="card-plans">
      <div class="plan-title">
        <span>{{ $t('cardPlans.buyPlan') }}</span>
      </div>
      <div class="products-list">
        <div class="product-item" :class="{current: currentIndex===index}" v-for="(item,index) in packageList" :key="index" @click="payDetails(item,index)">
          <div class="product-name">
              {{item.productName}}
          </div>
          <div class="product-price">
              <span>{{ item.currency }} {{ item.price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <span @click="toOrderListPage">{{ $t('cardPlans.orderList') }}</span>
      <span class="separator">|</span>
      <span @click="toUserAgreementPage">{{ $t('cardPlans.userAgreement') }}</span>
    </div>

    <nut-picker
        :is-visible="isVisible"
        :list-data="countryNames"
        :default-value-data="defaultCountry"
        @close="closeSwitch"
        @confirm="confirm"
    ></nut-picker>


    <!--弹出层-->
    <div class="modal"  v-if="!hideFlag">
      <div class="modal-cancel" @click="hideModal"></div>
      <div class="bottom-dialog-body">
          <div class='package-tip'>
            <span class="package-name">{{ propsParams.productName }}</span><img src="../../assets/img/x.svg"  class="package-x" @click='cancel'/>
          </div>
          <div class="separator-line"></div>
          <ul class='package-desc'>
            <li><div class="package-days">{{ this.$t('cardPlans.price') }}</div><div class="package-days-value" >{{ propsParams.currency }}{{ propsParams.price }} </div></li>
            <li><div class="package-days">{{ this.$t('cardPlans.flowCount') }}</div><div class="package-days-value" > {{ product.flowCount }} </div></li>
            <li><div class="package-days">{{ this.$t('cardPlans.validityTime') }}</div><div class="package-days-value" >{{ product.validityTime }}</div></li>
            <li><div class="package-days">{{ this.$t('cardPlans.switchCountryName') }}</div><div class="package-days-value" >{{ countryName }}</div></li>
            <li><div class="package-days">{{ this.$t('cardPlans.productDesc') }}</div><div class="package-days-value" >{{ this.$t('cardPlans.productDescText') }}</div></li>
          </ul>
          <div class="separator-line"></div>
          <div class="agreement-box">
            <nut-checkbox v-model="checkUserAgreement" size="base"></nut-checkbox><span style="color: #1890ff;text-decoration: underline" @click="toUserAgreementPage">{{ this.$t('cardPlans.userAgreement') }}</span>
          </div>
          <div class="separator-line"></div>
          <div class="pay-support">
            <div>{{ this.$t('cardPlans.paymentMethod') }}：</div>
            <div class="pay-support-list">
              <img src="../../assets/img/union-play.svg" class="pay-support-img" />
              <img src="../../assets/img/apple-pay.svg" class="pay-support-img" />
              <img src="../../assets/img/visa.svg" class="pay-support-img" />
              <img src="../../assets/img/google-pay.svg" class="pay-support-img" />
              <img src="../../assets/img/paypal.svg" class="pay-support-img" />
            </div>
          </div>
          <div class="pay-btn">
              <span class="pay-class">{{ this.$t('cardPlans.payBtnText') }}</span><img src="../../assets/img/paypal-btn.svg"  @click="pay()"/>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
import {getCountry, wx_internationalProductList, wx_internationalProductInfo , wx_internationalCountryList} from "@/api/api.js"; //获取套餐列表
import { wx_paypalPay } from "@/api/api.js"; //paypal充值
export default {
  data() {
    return {
      currentIndex:-1,
      packageList:[],
      msisdn:"",
      iccid:"",
      propsParams:{},
      cur:"",
      country:{}, // 获取的位置信息
      isVisible: false,
      countryNames:[],
      defaultCountry:[],
      countryName:'',
      countryList: [],
      switchCountryName:null,
      hideFlag: true,//true-隐藏 false-显示
      product: {},
      checkUserAgreement:true,
    };
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    switchCountry(){
      this.isVisible = true
      document.getElementsByClassName("nut-picker-cancel-btn")[0].innerText = this.$t('common.cancel');;
      document.getElementsByClassName("nut-picker-confirm-btn")[0].innerText = this.$t('common.confirm');
    },
    initCountryList(){
      wx_internationalCountryList().then(res=>{
        this.countryList = res.data.data
        let names = [];
        res.data.data.forEach(element => {
          let json = {
            label: element.id,
            value: this.$t('country.' + element.englishName),
          }
          names.push(json)
        })
        this.countryNames.push(names)
      })
    },
    closeSwitch() {
      this.isVisible = false;
    },
    confirm(chooseData) {
      this.countryName = chooseData[0].value;
      this.getProductList(chooseData[0].label)
    },
    // 切换套餐
    payDetails(val, index){
      this.currentIndex = index;
      this.propsParams = val;
      this.hideFlag = false;
      wx_internationalProductInfo({productId: this.propsParams.productId}).then(res=>{
        if(res.data.code == 200){
          this.product =  res.data.data
          this.product.flowCount = this.formatSize(this.product.flowCount);
          this.product.validityTime = this.product.validityTime + " days"
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    // 下单
    pay(){
      if(!this.checkUserAgreement){
        this.$toast.fail(this.$t('cardPlans.checkUserAgreementMsg'));
        return;
      }
      if(this.propsParams.currency == '￥'){
        this.$toast.fail(this.$t('cardPlans.payErrorMsg'));
        return;
      }
      if(this.propsParams.productId){
        let params ={
          currency:this.propsParams.currency,
          iccid:this.iccid ,
          price:this.propsParams.price,
          productId: this.propsParams.productId
        };
        wx_paypalPay(params).then(res=>{
          if(res.data.code == 200){
            window.location.href = res.data.data.return_url;
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }else{
        this.$toast.fail(this.$t('cardPlans.select'));
      }
    },
    // 国际流量获取国家位置
    initCardCountry(){
      getCountry({iccid : this.iccid}).then(res=>{
        if(res.data.code == 200){
          this.country = res.data.data
          let countryName = []
          countryName.push({
            label: this.country.id,
            value: this.$t('country.' + this.country.englishName),
          })
          this.defaultCountry = countryName
          console.log(this.country)
          console.log(this.defaultCountry)
          this.getProductList(this.country.id)
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    // 获取可购买的套餐列表
    getProductList(countryId){
      let params ={
        iccid:this.$route.query.iccid,
        countryId: countryId
      }
      wx_internationalProductList(params).then(res =>{
        if(res.data.code == 200){
          this.packageList = res.data.data.productList;
          this.msisdn = res.data.data.msisdn;
          this.iccid = res.data.data.iccid;
        }
      })
    },
    // 隐藏遮罩层
    hideModal() {
      this.hideFlag = true;
    },
    cancel() {
      this.hideFlag = true;
    },
    toOrderListPage(){
      this.$router.push({name: "orderList",query:{iccid:this.iccid}});
    },
    toUserAgreementPage(){
      this.$router.push({name: "userAgreement"});
    },
    formatSize: function (size) {
      let i, unit = ['MB', 'GB', 'TB', 'PB'];
      for (i = 0; i < unit.length && size >= 1024; i++) {
        size /= 1024;
      }
      return (Math.round(size * 100) / 100 || 0) +" "+ unit[i];
    },
  },
  created() {
    this.iccid = this.$route.query.iccid
    this.$i18n.locale = this.language;
    window.document.title = this.$t('cardLoop.title');
    this.initCountryList();
    this.initCardCountry();
  },
  mounted() {
    // window.document.title = this.$t('cardPlans.title');
  },
};
</script>
<style scoped lang="less">
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }
  .page{
    font-size: 14px;
    font-family: Avenir, Helvetica, Arial, sans-serif, 'Microsoft YaHei','PingFangSC-Regular','Roboto';
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #f8f8fa;
    .card-content{
      height: 100px;
      padding: 1.3rem 1.2rem;
      font-size: 1.1rem;
      display: flex;
      flex-direction: column;
      flex-flow: column nowrap;
      justify-content: flex-start;
      gap: 8px 12px;
      background-color: rgb(255, 255, 255);
      .card-country-item{
        display: flex;
        flex-direction: row;
        gap: 8px 12px;
        align-items: center;
      }
    }

    .card-plans{
      font-size: 1.1rem;
      padding: 1rem 1.2rem;
      background-color: rgb(255, 255, 255);
      height: calc(100vh  - 100px);
      .products-list{
        margin-top: 20px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, minmax(0px, 1fr));
        height: 8rem;
        gap: 8px 12.48px;
        .product-item{
          box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.06), 0 5px 12px 4px rgba(0, 0, 0, 0.04);
          height: 100%;
          border: 1px solid #0186D3;
          border-radius: 10px;
          color: #0186D3;
          font-size: 1.1rem;
          font-weight: bold;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 8px;
          &.current{
            background: #E5F6FE;
          }

        }
        

      }
    }

    .cur {
      background: #856ac9;
      border: 1px solid #856ac9 !important;
    }
    .cur p {
      color: #fff;
    }
    .cur .priceClass{
      color: #F94040;
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      color: #1890ff;
      .separator{
        margin: 0 10px;
      }
    }
    /*模态框*/
    .modal{position:fixed; top:0; right:0; bottom:0; left:0; z-index:1000;}
    .modal-cancel{position:absolute; z-index:2000; top:0; right:0; bottom: 0; left:0; background:rgba(0,0,0,0.3);}
    .bottom-dialog-body{width:100%;height: 60%;border-radius: 2%; position:absolute; z-index:3000; bottom:0; left:0;background: #f5f5f5;}
    .package-tip{
      height: 40px;
      width: 100%;
      line-height: 40px;
    }
    .package-name{
      width: 90%;
      padding-left: 12px;
      float:left;
    }
    .package-x{
      width: 10%;
      padding: 10px;
      float:right;
    }
    .separator-line{
      border: 1px solid #ededed;
      width: 90%;
      margin-left: 5%;
    }
    .package-desc{
      margin: 3%;
      height: 40%;
      li{
        width: 100%;
        height: 20%;
        display:flex;
        .package-days{
          width: 40%;
          flex:1;
        }
        .package-days-value{
          width: 40%;
          flex:1;
        }
      }
    }
    .agreement-box{
      margin: 3%;
    }
    .pay-support{
      margin: 3%;
    }
    .pay-support-list{
      margin: 2%;
    }
    .pay-support-img{
      width: 50px;
      height: 25px;
      border: 1px solid #ededed;
      padding:1%;
      margin-right: 1%;
    }
    .pay-btn{
      display: flex;
      justify-content: center;
      position: fixed;
      align-items: center;
      bottom: 0;
      width: 80%;
      margin-left: 10%;
      z-index: 23;
      background: #83a7c9;
      border-radius: 20px;
      padding: 1% 1%;
      height: 35px;
      line-height: 35px;
      margin-bottom: 5%;
      span{
        padding: 1% 1%;
        height: 18px;
        line-height: 14px;
        color:#f5f5f5;
        font-size: 16px;
      }
      img{
        width: 32%;
        font-size: 18px;
        height: 18px;
        line-height: 18px;
        // border: 1px solid #F94040 !important;
      }
    }

    /deep/ .nut-picker-cancel-btn{
      width: 80px;
      color: var(--nut-picker-cancel-color, #808080);
    }
    /deep/ .nut-picker-confirm-btn{
      width: 80px;
      color: var(--nut-picker-ok-color, var(--nut-primary-color, #fa2c19));
    }
  }

</style>

